<div>
  <div class="align-center" *ngIf="!newOrder.isReclaim">
    <br />
    <h2>{{ 'Skapa order' | translate }}</h2>
  </div>



  <!--  RECLAIM (ACE) -->
  <div class="row partner-store-admin-color" *ngIf="globals.userIsAce() && newOrder.isReclaim && reclaimedOrder">
    <div class="col align-right">
      <br />
      <h2 class="align-center" *ngIf="newOrder.isReclaim">{{ 'Reklamation av' | translate }} {{reclaimedOrder.orderNumber}}</h2>
      <!--
          <mat-checkbox [(ngModel)]="newOrder.isReclaim">{{ 'Reklamation' | translate }}</mat-checkbox>
        -->
    </div>


    <div class="col-12">
      <div class="row">

        <!--
            <div class="col-6">
              <mat-form-field class="fullwidth">
                <mat-label>{{ 'Ursprungligt ordernummer' | translate }}</mat-label>
                <input type="text" matInput [(ngModel)]="newOrder.reclaimOrderNumber">
              </mat-form-field>
            </div>
          -->
        <div class="col-6">
          <mat-form-field class="fullwidth">
            <mat-label class="admin-color">{{ 'Vem fuckade upp?' | translate }}</mat-label>
            <mat-select [(ngModel)]="newOrder.reclaimBlame" (selectionChange)="reclaimBlameChanged()">
              <mat-option [value]="'ACE'">ACE</mat-option>
              <mat-option [value]="'PRINT_PARTNER'">{{ 'Exakta' | translate }}</mat-option>
              <mat-option [value]="'PARTNER'">{{ 'Partner' | translate }}</mat-option>
              <mat-option [value]="'DELIVERY'">{{ 'Fraktbolag' | translate }}</mat-option>
              <mat-option [value]="'CUSTOMER'">{{ 'Slutkund' | translate }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>


        <div class="col-6 align-right" *ngIf="globals.storeSettings.type == 'partner'">
          <mat-form-field>
            <mat-label class="admin-color">{{ 'Återbetalning till partner' | translate }}</mat-label>
            <input type="number" matInput [(ngModel)]="newOrder.partnerCreditsToRefund">
          </mat-form-field>
          <div *ngIf="!reclaimedOrder.creditTransactionId">{{ 'Ordern som reklameras har ännu inte debiterats partnern. Om denna ordern avbryts i samband med reklamationen så behövs ingen återbealning.' | translate }}</div>
        </div>
        <div class="col-12">
          <mat-form-field class="fullwidth">
            <mat-label class="admin-color">{{ 'Vad fan hände då?' | translate }}</mat-label>
            <textarea matInput [(ngModel)]="newOrder.reclaimDescription"></textarea>
          </mat-form-field>
        </div>

        <div class="col-12 align-right admin-color">
          <mat-checkbox [(ngModel)]="newOrder.cancelReclaimedOrder" color="primary">{{ 'Avbryt ordern som reklamerades' | translate }}</mat-checkbox>
        </div>
      </div>
    </div>
  </div>


  <!--  RECLAIM (PARTNER) -->
  <div class="row partner-color" *ngIf="!globals.userIsAce() && newOrder.isReclaim && reclaimedOrder">
    <div class="col align-right">
      <br />
      <h2 class="align-center" *ngIf="newOrder.isReclaim">{{ 'Reklamation av' | translate }} {{reclaimedOrder.orderNumber}}</h2>
      <!--
              <mat-checkbox [(ngModel)]="newOrder.isReclaim">{{ 'Reklamation' | translate }}</mat-checkbox>
            -->
    </div>


    <div class="col-12">
      <div class="row">
        <div class="col-4">
          <mat-form-field class="fullwidth">
            <mat-label class="partner-color">{{ 'Vem gjorde fel?' | translate }}</mat-label>
            <mat-select [(ngModel)]="newOrder.reclaimBlame" (selectionChange)="reclaimBlameChanged()">
              <mat-option [value]="'PARTNER'">{{ 'Butiken' | translate }}</mat-option>
              <mat-option [value]="'CUSTOMER'">{{ 'Slutkunden' | translate }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-8">
          <mat-form-field class="fullwidth">
            <mat-label class="partner-color">{{ 'Beskrivning' | translate }}</mat-label>
            <input type="text" matInput [(ngModel)]="newOrder.reclaimDescription">
          </mat-form-field>
        </div>
        <div class="col-12 align-right partner-color">
          <mat-checkbox [(ngModel)]="newOrder.cancelReclaimedOrder" color="primary">{{ 'Avbryt ordern som reklamerades' | translate }}</mat-checkbox>
        </div>
      </div>
    </div>
  </div>

  <br />
  <br />

  <div class="row">
    <div class="col-12">
      <h3 class="align-center">{{ 'Produkter' | translate }}</h3>
      <table class="styled fullwidth">
        <tr>
          <td>{{ 'Typ' | translate }}</td>
          <td>SKU</td>
          <td class="align-right">{{ 'Antal' | translate }}</td>
          <td></td>
        </tr>
        <tr *ngFor="let item of newOrder.items">
          <td style="width:150px;">
            <mat-form-field class="">
              <mat-select [(ngModel)]="item.type">
                <mat-option *ngIf="globals.userIsAce()" [value]="'CUSTOM'">{{ 'Endast SKU' | translate }}</mat-option>
                <mat-option [value]="'POSTER'">{{ 'Poster' | translate }}</mat-option>
                <mat-option [value]="'CANVAS'">{{ 'Canvas' | translate }}</mat-option>
          <!--      <mat-option [value]="'TSHIRT'">{{ 'T-Shirt' | translate }}</mat-option> -->
                <mat-option [value]="'CLOTHES'">{{ 'Kläder' | translate }}</mat-option>
                <mat-option [value]="'STOCK_ITEM'">{{ 'Stock Item' | translate }}</mat-option>
                <mat-option [value]="'OTHER'">{{ 'Övrigt' | translate }}</mat-option>
              </mat-select>
            </mat-form-field>
          </td>
          <td>
            <mat-form-field class="fullwidth" *ngIf="item.type == 'CUSTOM'">
              <input type="text" matInput [(ngModel)]="item.sku">
            </mat-form-field>

            <ng-container *ngIf="item.type == 'CLOTHES'">
              <div class="row">
                <div class="col-auto">
                  <mat-form-field class="fullwidth">
                    <mat-select [(ngModel)]="selectedClothesCategory[item.identifier]">
                      <mat-option [value]="'TSHIRT'">{{ 'T-Shirt' | translate }}</mat-option>
                      <mat-option [value]="'HOODIE'">{{ 'Hoodie' | translate }}</mat-option>
                      <mat-option [value]="'SWEATSHIRT'">{{ 'Sweatshirt' | translate }}</mat-option>
                      <mat-option [value]="'KIDS'">{{ 'Barn' | translate }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="col-auto">
                    <mat-form-field class="fullwidth">
                      <mat-select [(ngModel)]="item.location">
                        <mat-option [value]="'FRONT'">{{ 'Front' | translate }}</mat-option>
                        <mat-option [value]="'BACK'">{{ 'Back' | translate }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                <div class="col">
                  <mat-form-field class="fullwidth">
                    <mat-select [(ngModel)]="item.sku">
                      <mat-option *ngFor="let sku of clothesSKUsByCategory[selectedClothesCategory[item.identifier]]"
                        [value]="sku">
                        <ng-container *ngIf="productNamesBySKU[sku]">{{productNamesBySKU[sku]}}</ng-container>
                        <ng-container *ngIf="!productNamesBySKU[sku]">{{sku}}</ng-container>
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            </ng-container>

            <mat-form-field class="fullwidth" *ngIf="!['CUSTOM', 'CLOTHES'].includes(item.type)">
              <mat-select [(ngModel)]="item.sku">
                <mat-option *ngFor="let skuInfo of availableSkuInfoByPosterType[item.type]" [value]="skuInfo.sku">
                  <ng-container *ngIf="productNamesBySKU[skuInfo.sku]">{{productNamesBySKU[skuInfo.sku]}}</ng-container>
                  <ng-container *ngIf="!productNamesBySKU[skuInfo.sku]">{{skuInfo.sku}}</ng-container>
                </mat-option>
              </mat-select>
            </mat-form-field>
          </td>
          <td class="align-right" style="width:100px;">
            <mat-form-field>
              <input class="align-right" type="number" matInput [(ngModel)]="item.quantity">
            </mat-form-field>
          </td>
          <td class="align-right">
            <button class="styled slim" mat-raised-button color="primary" (click)="removeItem(item)">{{ 'Ta bort' | translate }}</button>
          </td>
        </tr>
      </table>
      <div class="align-right">
        <button class="styled" mat-raised-button color="primary" (click)="addItem()">{{ 'Lägg till' | translate }}</button>
      </div>
    </div>
  </div>

  <br />
  <br />

  <div class="row">
    <div class="col-12">
      <h3 class="align-center">{{ 'Kund' | translate }}</h3>
      <div class="row">
        <div class="col-4">
          <mat-form-field class="fullwidth">
            <mat-label>{{ 'Förnamn' | translate }}</mat-label>
            <input type="text" matInput [(ngModel)]="newOrder.shippingInfo.firstName">
          </mat-form-field>
        </div>
        <div class="col-4">
          <mat-form-field class="fullwidth">
            <mat-label>{{ 'Efternamn' | translate }}</mat-label>
            <input type="text" matInput [(ngModel)]="newOrder.shippingInfo.lastName">
          </mat-form-field>
        </div>
        <div class="col-4">
          <mat-form-field class="fullwidth">
            <mat-label>{{ 'Epost' | translate }}</mat-label>
            <input type="text" matInput [(ngModel)]="newOrder.shippingInfo.email">
          </mat-form-field>
        </div>
        <div class="col-4">
          <mat-form-field class="fullwidth">
            <mat-label>{{ 'Telefon' | translate }}</mat-label>
            <input type="text" matInput [(ngModel)]="newOrder.shippingInfo.phone">
          </mat-form-field>
        </div>
        <div class="col-4">
          <mat-form-field class="fullwidth">
            <mat-label>{{ 'Adress' | translate }}</mat-label>
            <input type="text" matInput [(ngModel)]="newOrder.shippingInfo.address1">
          </mat-form-field>
        </div>
        <div class="col-4">
          <mat-form-field class="fullwidth">
            <mat-label>{{ 'Postkod' | translate }}</mat-label>
            <input type="text" matInput [(ngModel)]="newOrder.shippingInfo.zipCode">
          </mat-form-field>
        </div>
        <div class="col-4">
          <mat-form-field class="fullwidth">
            <mat-label>{{ 'Ort' | translate }}</mat-label>
            <input type="text" matInput [(ngModel)]="newOrder.shippingInfo.city">
          </mat-form-field>
        </div>
        <div class="col-4">
          <mat-form-field class="fullwidth">
            <mat-label>{{ 'Företag' | translate }}</mat-label>
            <input type="text" matInput [(ngModel)]="newOrder.shippingInfo.company">
          </mat-form-field>
        </div>
        <div class="col-4">
          <mat-form-field class="">
            <mat-label>{{ 'Land' | translate }}</mat-label>
            <mat-select [(ngModel)]="newOrder.shippingInfo.country">
              <mat-option *ngFor="let country of availableCountryCodes" [value]="country">{{country}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-4">
          <br />
          <mat-checkbox [(ngModel)]="newOrder.sendShippingDispatchEmail" color="primary">{{ 'Skicka spårningslänk till kunden' | translate }}</mat-checkbox>
        </div>
      </div>
    </div>

  </div>

  <div class="row">
    <div class="col">
      <br />
      <br />
      <button class="styled fullwidth" [disabled]="creatingOrder" mat-raised-button color="primary"
        (click)="createOrder()">{{ 'Skapa order & fortsätt till uppladdning' | translate }}</button>
      <br />
      <br />
      <br />
      <br />
    </div>
  </div>
